import { httpDelete, httpGet, httpPatch, httpPost } from "@/api/connection";
import {
  CreateTaskBody,
  CreateTaskResponse,
  DeleteTaskPathParams,
  DeleteTaskResponse,
  GetTasksQuery,
  GetTasksResponse,
  UpdateTaskInput,
  UpdateTaskResponse,
} from "./tasks.types";

type GetTasksFn = (query?: GetTasksQuery) => Promise<GetTasksResponse>;
type CreateTaskFn = (data: CreateTaskBody) => Promise<CreateTaskResponse>;
type UpdateTaskFn = (data: UpdateTaskInput) => Promise<UpdateTaskResponse>;
type DeleteTaskFn = (data: DeleteTaskPathParams) => Promise<DeleteTaskResponse>;

const baseUrl = "/tasks/v3";

const getTasks: GetTasksFn = async (query = {}) => {
  const { uuid, ...rest } = query;

  if (uuid) {
    return httpGet(`${baseUrl}/${uuid}`, rest);
  }

  return httpGet(baseUrl, rest);
};

const createTask: CreateTaskFn = async (data) => {
  return httpPost(baseUrl, data);
};

const updateTask: UpdateTaskFn = async (data) => {
  const { uuid, ...rest } = data;
  return httpPatch(`${baseUrl}/${uuid}`, rest);
};

const deleteTask: DeleteTaskFn = async (data) => {
  return httpDelete(`${baseUrl}/${data.uuid}`);
};

export const TasksAPI = {
  get: getTasks,
  create: createTask,
  update: updateTask,
  delete: deleteTask,
};
